export default __webpack_public_path__ + "static/media/GF_FURY.095b95e8.jpg";